export enum REVIEW_TABS {
  JOBS = 'Jobs',
  EMPLOYEE = 'Employee',
}

export enum REVIEW_MODES {
  ITEMWISE = 'Items',
  EMPLOYEEWISE = 'Employees',
}

export interface ReviewMode {
  tab: REVIEW_TABS;
  mode: REVIEW_MODES;
}

export const DAYS: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
